import {
  GET_COLLECTION_ITEM,
  GET_COLLECTION_ITEM_SUCCESS,
  GET_COLLECTION_ITEM_ERROR,
  UPDATE_COLLECTION_ITEM,
  UPDATE_COLLECTION_ITEM_SUCCESS,
  UPDATE_COLLECTION_ITEM_ERROR,
  CLEAR_COLLECTION_ITEM
} from "../actions";

export const getCollectionItem = (collectionItemId, activityInfo) => ({
  type: GET_COLLECTION_ITEM,
  payload: { collectionItemId, activityInfo },
});

export const getCollectionItemSuccess = (collectionItem) => ({
  type: GET_COLLECTION_ITEM_SUCCESS,
  payload: collectionItem,
});

export const getCollectionItemError = (message) => ({
  type: GET_COLLECTION_ITEM_ERROR,
  payload: { message },
});

export const updateCollectionItem = (collectionItem, history) => ({
  type: UPDATE_COLLECTION_ITEM,
  payload: { collectionItem, history },
});

export const updateCollectionItemSuccess = (collectionItem) => ({
  type: UPDATE_COLLECTION_ITEM_SUCCESS,
  payload: collectionItem,
});

export const updateCollectionItemError = (message) => ({
  type: UPDATE_COLLECTION_ITEM_ERROR,
  payload: { message },
});

export const clearCollectionItem = () => ({
  type: CLEAR_COLLECTION_ITEM,
  payload: {}
})